import React, { Component } from "react";
import ReactEcharts from 'echarts-for-react';

class StaitEcharts extends Component {

  getOption = (data) => {
    let dataList = []
    if (data.hasOwnProperty("TOTAL_RECEIVE")) {
      dataList.push(data.TOTAL_RECEIVE)   // 总上传量
      dataList.push(data.TOTAL_CONSULTATION) // 总有效量
      dataList.push(data.TOTAL_EXIT)     // 总退回量
    } else {
      dataList.push(data.SUBMIT_COUNT)   // 总上传量
      dataList.push(data.COMPLETE_COUNT) // 总有效量
      dataList.push(data.EXIT_COUNT)     // 总退回量
    }
    let option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: {
        type: 'category',
        data: ['总上传量', '总会诊量', '总退回量'],
        axisTick: {
          alignWithLabel: true
        }
      },
      yAxis: {
        type: 'value'
      },
      series: [{
        data: dataList,
        type: 'bar',
        itemStyle: {
          normal: {
            color: (params) => {
              var colorList = ["#00A2E8", "#70CFA9", "#F36971"];
              return colorList[params.dataIndex]
            }
          }
        },
      }],
    }
    return option;
  }

  render() {
    const { dataStats } = this.props
    return (
      <>
        <ul className="legend">
          <li><span></span>总上传量</li>
          <li><span></span>总会诊量</li>
          <li><span></span>总退回量</li>
        </ul>
        <ReactEcharts
          style={{ width: "600px", height: "320px" }}
          option={this.getOption(dataStats)}
        />
      </>
    );
  }
}

export default StaitEcharts;